import { APILookupValue, APIObject } from "@/services/api/types";
import { TFunction } from "i18next";
import { camelCase, chain } from "lodash";

type KeyExtractor<T> = (item: T) => (string | undefined | null)[];

export function flattenDataByKeys<T>(
  data: T[] | undefined,
  keyExtractor: KeyExtractor<T>
): string[] {
  return chain(data).flatMap(keyExtractor).compact().uniq().value();
}

export function createDataMapById<
  T extends APIObject | { id: string | number }
>(data: (T | undefined)[]): Record<string, T> {
  return chain(data).compact().keyBy("id").value();
}

export const LookupNameFromIdx = (
  t: TFunction<"translation", undefined>,
  translationPrefix: string,
  lookupValues: APILookupValue[],
  value: number
) => {
  const lookupValue = lookupValues.find((i) => i.id === value);
  if (lookupValue) {
    // Skip camelCase transformation for "N/A" to preserve the original format
    if (lookupValue.name === "N/A") {
      return lookupValue.name;
    }
    return t(`${translationPrefix}.${camelCase(lookupValue.name)}`, {
      defaultValue: lookupValue.name
    });
  }
  return t("tables.notAvailable");
};
